import axios from "axios";
import wx from "weixin-js-sdk";

export function initWxJsApiConfig() {
    return axios({
      url: "v1/wx_js_api_config",
      method: "get",
      params: {
        url: window.location.href.split('#')[0]
      }
    }).then(({ data }) => {
      return new Promise((resolve, reject) => {
        wx.config({
          // debug: true,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
        });
        wx.ready(() => {
          initWxShareContent();
          resolve();
        });
        wx.error((err) => {
          reject(err);
        });
      });
    });
  }

  export function initWxShareContent(logo, name) {
    // 自定义分享给朋友
    //
    let sharelink = window.location.href;
    wx.onMenuShareAppMessage({
      title: name,
      desc: "来自有朋相册",
      link: encodeURI(sharelink),
      imgUrl: logo,
      success: function() {
        console.log({ shareToFriend: "success" });
      },
      cancel: function() {
        console.log({ shareToFriend: "cancel" });
      },
      fail: function() {
        console.error({ shareToFriend: "fail" });
      }
    });
  
    // 自定义分享给朋友圈的内容
    //
    wx.onMenuShareTimeline({
      title: "我的照片",
      link: encodeURI(sharelink),
      imgUrl: logo,
      success: function() {
        console.log({ shareToTimeline: "success" });
      },
      cancel: function() {
        console.log({ shareToTimeline: "cancel" });
      },
      fail: function() {
        console.error({ shareToTimeline: "fail" });
      }
    });
    console.log("initWxShareContent is called");
  }